"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNewebPayQueryRequest = instanceOfNewebPayQueryRequest;
exports.NewebPayQueryRequestFromJSON = NewebPayQueryRequestFromJSON;
exports.NewebPayQueryRequestFromJSONTyped = NewebPayQueryRequestFromJSONTyped;
exports.NewebPayQueryRequestToJSON = NewebPayQueryRequestToJSON;
exports.NewebPayQueryRequestToJSONTyped = NewebPayQueryRequestToJSONTyped;
/**
 * Check if a given object implements the NewebPayQueryRequest interface.
 */
function instanceOfNewebPayQueryRequest(value) {
    if (!('merchantOrderNo' in value) || value['merchantOrderNo'] === undefined)
        return false;
    return true;
}
function NewebPayQueryRequestFromJSON(json) {
    return NewebPayQueryRequestFromJSONTyped(json, false);
}
function NewebPayQueryRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'merchantOrderNo': json['merchantOrderNo'],
    };
}
function NewebPayQueryRequestToJSON(json) {
    return NewebPayQueryRequestToJSONTyped(json, false);
}
function NewebPayQueryRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'merchantOrderNo': value['merchantOrderNo'],
    };
}
